import * as React from 'react'
import {connect} from 'react-redux'
import Select, {
  components,
  createFilter,
  CSSObjectWithLabel,
  MenuListProps,
  OptionProps,
  SingleValue
} from 'react-select'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {IFeatureLayerInfo} from '../../core/interfaces/models'
import {IFeatureLayerInfos} from '../../core/interfaces/reducers'
import {Feature} from '../../core/models'
import {ServiceHub} from '../../core/ServiceHub'
import {IAppStore} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'

interface ParentProps {
  selectedSettlemet?: Feature
  selectedLocation?: Feature
  hideLocations?: boolean
  onSettlementsChange: (allLocations: Feature[], selectedSettlemet?: Feature, selectedLocation?: Feature) => void
}

interface OwnProps {
  layerInfos: IFeatureLayerInfos
}

type Props = OwnProps & ParentProps

interface State {
  settlementsLoading: boolean
  locationsLoading: boolean
  settlements: Feature[]
  locations: Feature[]
  error?: string
  dispatcherSettLoading: boolean
}

class LocationSelectorClass extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      settlementsLoading: true,
      locationsLoading: true,
      settlements: [],
      locations: [],
      dispatcherSettLoading: false
    }
  }
  _ismounted: boolean
  componentDidMount() {
    this._ismounted = true
    if (
      this.props.layerInfos[appConfig.common.settlements.settlementsUrl] &&
      this.props.layerInfos[appConfig.common.locations.locationsUrl] &&
      !this.state.dispatcherSettLoading
    ) {
      this.setState({...this.state, dispatcherSettLoading: true}, () => {
        this.loadSettlements(
          this.props.layerInfos[appConfig.common.settlements.settlementsUrl],
          this.props.layerInfos[appConfig.common.locations.locationsUrl]
        )
      })
    }
  }

  componentWillUnmount() {
    this._ismounted = false
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.layerInfos !== this.props.layerInfos &&
      this.props.layerInfos[appConfig.common.settlements.settlementsUrl] &&
      this.props.layerInfos[appConfig.common.locations.locationsUrl] &&
      !this.state.dispatcherSettLoading
    ) {
      this.setState({...this.state, dispatcherSettLoading: true}, () => {
        this.loadSettlements(
          this.props.layerInfos[appConfig.common.settlements.settlementsUrl],
          this.props.layerInfos[appConfig.common.locations.locationsUrl]
        )
      })
    }
  }

  loadSettlements(settlementsInfo: IFeatureLayerInfo, locationsInfo: IFeatureLayerInfo) {
    if (!this._ismounted) {
      return
    }
    ServiceHub.gisCrudService
      .execute(settlementsInfo, {where: '1=1'})
      .then(r => {
        if (!this._ismounted) {
          return
        }
        if (this.props.selectedSettlemet) {
          this.setState({...this.state, error: '', settlementsLoading: false, settlements: r}, () => {
            this.loadLocations(this.props.selectedSettlemet!, locationsInfo)
          })
        } else {
          this.setState({...this.state, error: '', settlementsLoading: false, locationsLoading: false, settlements: r})
        }
      })
      .catch(e => {
        if (!this._ismounted) {
          return
        }
        this.setState({...this.state, error: 'Възникна грешка', settlementsLoading: false, locationsLoading: false})
      })
  }

  loadLocations(selectedSettlement: Feature, locationsInfo: IFeatureLayerInfo) {
    this.setState({...this.state, error: '', locationsLoading: true, locations: []})
    ServiceHub.gisCrudService
      .execute(locationsInfo, {where: `"SettlementId" = '${selectedSettlement.getProperties()['EKATTE']}'`})
      .then(r1 => {
        this.setState({...this.state, locationsLoading: false, locations: r1}, () => {
          this.props.onSettlementsChange(
            this.state.locations,
            selectedSettlement,
            selectedSettlement ? this.props.selectedLocation : undefined
          )
        })
      })
      .catch(e => {
        this.setState({...this.state, error: 'Възникна грешка', settlementsLoading: false, locationsLoading: false})
      })
  }

  getSettlements() {
    const info = this.props.layerInfos[appConfig.common.settlements.settlementsUrl]
    const locationsInfo = this.props.layerInfos[appConfig.common.locations.locationsUrl]

    let selectOptions = [{value: '', label: ''}]

    if (info) {
      selectOptions = this.state.settlements.map(settlement => ({
        value: settlement.getProperties()[info.sourceDescription.idField],
        label: `${settlement.getProperties()['EKATTE']} ${settlement.getProperties()['Name']}, общ. ${
          settlement.getProperties()['Municipality']
        }`
      }))
    }

    return (
      <Select
        isSearchable={true}
        styles={{
          container: (provided: CSSObjectWithLabel) => ({...provided, marginBottom: '10px'})
        }}
        className="settlement-select"
        options={selectOptions}
        placeholder="Изберете населено място"
        filterOption={createFilter({ignoreAccents: false})}
        components={{
          MenuList: (props: MenuListProps<any, false>) => (
            <components.MenuList {...props}>
              {Array.isArray(props.children) ? props.children.slice(0, 50) : props.children}
            </components.MenuList>
          ),
          Option: ({children, ...props}: OptionProps<any, false>) => {
            const {onMouseMove, onMouseOver, ...rest} = props.innerProps as any
            const newProps = {...props, innerProps: rest}
            return (
              <components.Option {...newProps} className="custom-select-option">
                {children}
              </components.Option>
            )
          }
        }}
        onChange={(e: SingleValue<any>) => {
          if (e && info && locationsInfo) {
            const newSelectedSettlement = this.state.settlements.find(
              s => s.getProperties()[info.sourceDescription.idField].toString() == e.value
            )
            const settIsDiff =
              newSelectedSettlement &&
              this.props.selectedSettlemet &&
              newSelectedSettlement.getProperties()['Id'] != this.props.selectedSettlemet.getProperties()['Id']
            this.props.onSettlementsChange(
              this.state.locations,
              newSelectedSettlement,
              !settIsDiff ? this.props.selectedLocation : undefined
            )
            if (newSelectedSettlement) {
              this.loadLocations(newSelectedSettlement, locationsInfo)
            } else {
              this.setState({...this.state, locations: []}, () => {
                this.props.onSettlementsChange(
                  this.state.locations,
                  newSelectedSettlement,
                  newSelectedSettlement ? this.props.selectedLocation : undefined
                )
              })
            }
          }
        }}
      />
    )
  }

  getLocations() {
    const info = this.props.layerInfos[appConfig.common.locations.locationsUrl]
    const def = {value: 'null', label: 'Изберете местност'}
    const options: {value: any; label: any}[] = []
    this.state.locations.forEach((s, i) => {
      options.push({value: s.getProperties()[info.sourceDescription.idField], label: s.getProperties()['Name']})
    })
    let currentValue = def
    if (this.props.selectedLocation) {
      for (let i = 0; i < options.length; i++) {
        if (options[i].value == this.props.selectedLocation.getProperties()[info.sourceDescription.idField]) {
          currentValue = options[i]
        }
      }
    }

    return (
      <Select
        isSearchable={true}
        value={currentValue}
        placeholder="Изберете местност"
        className="location-select"
        isDisabled={this.state.locations.length === 0}
        onChange={(newValues: {value: any; label: any}) => {
          if (info) {
            const newSelectedLocation = this.state.locations.find(
              s => s.getProperties()[info.sourceDescription.idField].toString() == newValues.value
            )
            this.props.onSettlementsChange(this.state.locations, this.props.selectedSettlemet, newSelectedLocation)
          }
        }}
        options={options}
      />
    )
  }

  render() {
    return (
      <div className="location-selector">
        <OverlayLoader show={this.state.locationsLoading || this.state.settlementsLoading}></OverlayLoader>
        <div className="wrapper">
          <div>
            <span>Изберете местност</span>
            <button
              type="button"
              className="button"
              disabled={!this.props.selectedSettlemet}
              onClick={() => (window.location.href = '/new-locality')}
              style={{minHeight: 24, padding: '0 8px', marginTop: 4}}
            >
              <i className="fas fa-plus" style={{marginRight: '8px'}} /> Нова местност
            </button>
          </div>
          <div>
            {this.getSettlements()}
            {this.props.hideLocations ? null : this.getLocations()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store: IAppStore) => ({
  layerInfos: store.layerInfos.featureLayerInfos
})

export const LocationSelector = connect<OwnProps, {}, ParentProps>(mapStateToProps)(LocationSelectorClass)
